module.exports = __webpack_public_path__ + "static/media/zhinnegkefu_140.ff302c42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/zhinnegkefu_140.svg
// module id = 692
// module chunks = 0